import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { legendValid } from '../../utils/legend.data.util';
import { inventoryTypeList, inventoryTypeValue } from '../../libraries/inventory.type.library';
import { suffixLegend } from '../../scripts/name.legend.script';

import AppLegend from './Legend';

export interface AppInputFeatureTypeProps {
  options: {index: number, item: {id: string, type: string, name: string}} | null,
  typeFeature?: {value: string, valid: boolean},
  features?: {value: {id: string, type: string, name: string, options: string[]}[], valid: {type: boolean, name: boolean, options: boolean}[]},
  setTypeFeature?: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setFeatures?: Dispatch<SetStateAction<{value: {id: string, type: string, name: string, options: string[]}[], valid: {type: boolean, name: boolean, options: boolean}[]}>>
};

const AppInputFeatureType: React.FunctionComponent<AppInputFeatureTypeProps> = ({options, typeFeature, features, setTypeFeature, setFeatures}) => {
  const {lang} = StateLanguage()

  const handleChangeType = (item: string) => {
    if (typeFeature && setTypeFeature) {
      setTypeFeature({value: item, valid: true})
      legendValid("legend-feature-type-required")
    }
  }

  const handleChangeFeatureTypeList = (index: number, item: string) => {
    if (features && setFeatures) {
      let tempFeaturesValue = features.value.map((temp_item, temp_index) => {
        if (index === temp_index) {
          temp_item.type = item
        }
        return temp_item
      })
      let tempFeaturesValid = features.valid.map((temp_item, temp_index) => {
        if (index === temp_index) {
          temp_item.type = true
        }
        return temp_item
      })

      setFeatures({value: tempFeaturesValue, valid: tempFeaturesValid})
      legendValid(`legend-feature-type-required${suffixLegend(index)}`)
    }
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select">
              <span className="select2-selection__rendered" role="textbox">
                { typeFeature &&
                  <>
                    {typeFeature.valid ? inventoryTypeValue(lang, typeFeature.value) : lang.labels.selectOption}
                  </>
                }
                { options && features &&
                  <>
                  {features && features.valid[options.index].type ? inventoryTypeValue(lang, options.item.type) : lang.labels.selectOption}
                  </>
                }
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox">
                { typeFeature && inventoryTypeList(lang).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${typeFeature.value === item.code && "select2-results__option--selected"}`} role="option" aria-selected={typeFeature.value === item.code}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeType(item.code)}>{item.display}</Dropdown.Item>
                  </li>
                )}))}
                { options && features && inventoryTypeList(lang).map (( (sub_item, sub_index) => { return (
                  <li key={sub_index} className={`select2-results__option select2-results__option--selectable ${options.item.type === sub_item.code && "select2-results__option--selected"}`} role="option" aria-selected={options.item.type === sub_item.code}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeFeatureTypeList(options.index, sub_item.code)}>{sub_item.display}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
      { typeFeature &&
        <>
          <AppLegend attribute={{check: typeFeature.valid, name: "feature-type", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
        </>
      }
      { options && features &&
        <>
          <AppLegend attribute={{check: features.valid[options.index].type, name: "feature-type", index: options.index, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
        </>
      }
    </>
  )
}

export default AppInputFeatureType;
